let productMainCarouselTrackedProduct;
function defineFirstProductInfo(productInfo) {
  if (!productMainCarouselTrackedProduct) productMainCarouselTrackedProduct = JSON.parse(productInfo);
}
document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.accordion-item');
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  activateProduct('sublyme');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function () {
      const product = this.parentElement.getAttribute('data-product');
      activateProduct(product);
    });
  });
  function activateProduct(productId) {
    accordionItems.forEach(item => {
      item.classList.remove('active');
    });

    const selectedItem = document.querySelector(`.accordion-item[data-product="${productId}"]`);
    if (selectedItem) {
      selectedItem.classList.add('active');
    }
  }

  let currentIndex = 2;
  const products = ['sublyme', 'caffeine', 'koala'];

  function autoplayAccordion() {
    currentIndex = (currentIndex + 1) % products.length;
    activateProduct(products[currentIndex]);
  }

  const autoplayInterval = setInterval(autoplayAccordion, 3500);

  accordionItems.forEach(item => {
    item.addEventListener('mouseenter', function () {
      clearInterval(autoplayInterval);
    });
  });
});

function handleSelectChange(selectElement, blockId) {
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const productData = JSON.parse(JSON.parse(selectedOption.value))

  const imgElement = document.getElementById(`productImageMobile--${blockId}`);
  imgElement.src = productData.imageUrl;

  const priceElement = document.getElementById(`pcmPriceMobile--${blockId}`);
  priceElement.innerHTML = formatCurrency(productData.price);

  const variantInputElement = document.getElementById(`inputVariant--${blockId}`)
  variantInputElement.value = productData['variantId'];
}

function handleChangeProduct(productInfo, blockId, productHandle) {
  const productData = JSON.parse(productInfo);
  productMainCarouselTrackedProduct = productData;
  const imgElement = document.getElementById(`productImage--${blockId}`);
  imgElement.src = productData.imageUrl;

  const priceElement = document.getElementById(`pcmPrice--${blockId}`);
  priceElement.innerHTML = formatCurrency(productData.price);

  const variantInputElement = document.getElementById(`inputVariant--${blockId}`)
  variantInputElement.value = productData.variantId;

  handleTagSelection(blockId, productHandle)
}

function handleTagSelection(blockId, productHandle) {
  const allSelectedTags = document.querySelectorAll(`.pcm-tag-selected--${blockId}`);
  allSelectedTags.forEach(tag => {
    tag.classList.remove(`pcm-tag-selected--${blockId}`)
    tag.classList.remove('pmc-tag-selected')
  });

  const currentTag = document.querySelector(`.pcm-tag--${productHandle}`);
  currentTag.classList.add(`pcm-tag-selected--${blockId}`);
  currentTag.classList.add(`pmc-tag-selected`);
}

function handleSendProductDataToTracking() {
  if (productMainCarouselTrackedProduct) {
    insiderTracking.handleHomepageAddToCart(productMainCarouselTrackedProduct, "homepage_product");
  }
}

